
	BaseComponent = Ractive.extend({
		isolated: true,
		paths: {
			base: '/opfiles/ys/redmarine'
		},
		partials: RedmarinePartials,
		loadStyles: function(component) {
			var i,
				url,
				stylesCount,
				existingStyles = document.getElementsByTagName('link');

			// TODO: this path should link to compiled css files folder
			url = this.paths.base + '/components/' + component + '/' + component + '.css';

			for (i = 0, stylesCount = existingStyles.length; i < stylesCount; i++) {
				var curStyle = existingStyles[i];
				if (curStyle.getAttribute('rel') === 'stylesheet' && curStyle.getAttribute('href') === url) {
					break;
				}
			}

			if (i === stylesCount) { // stylesheet is not included yet, so add it
				var customStyles = document.createElement('link');
				customStyles.setAttribute('rel', 'stylesheet');
				customStyles.setAttribute('href', url);
				document.getElementsByTagName('head')[0].appendChild(customStyles);
			}
		},
		onconstruct: function() {
			this.loadStyles(this.data.component);
		}
	});

